<template>
  <div>
    <Carousel v-if="mounted" @click="handleMouseMove" @mousemove="handleMouseMove" ref="myCarousel" :items-to-show="1"
      :items-to-scroll="1" wrap-around>
      <Slide v-for="(image, index) in images" :key="index">
        <div class="slide-content w-full max-h-screen" :class="{
          'h-screen flex items-center': isExpanded,
          'zoomed': isZoomed && index === $refs.myCarousel.data.currentSlide,
          'zooming': isZooming && index === $refs.myCarousel.data.currentSlide,
          'cursor-zoom-out': isZoomed && isExpanded,
          'cursor-zoom-in': !isZoomed && isExpanded
        }" @click="toggleZoom" :style="{
          transform: isZoomed && index === $refs.myCarousel.data.currentSlide
            ? `translate(${translateX}px, ${translateY}px) scale(${scaleFactor})`
            : 'none'
        }">
          
          <UiProductImage class="w-full max-h-screen object-contain" :altText="image.altText" :title="image.altText" :url="image.url" fit="crop"
            :sizes="sizes" />
        </div>
      </Slide>

      <template #addons>


        <div class="navigationwrapper">
          <div class="flex items-end justify-end">
            <button class="zoombutton pr-5 underline" @click="$emit('mytoggle')">
              <span v-if="!isExpanded" class="outline-none"> Full screen </span>
              <UiClose v-else />
            </button>

            <Navigation>
              <!-- Replace the default "previous" icon -->

              <template #prev>
                <Arrow />
              </template>
              <template #next>
                <Arrow class="rotate-180" />
              </template>

            </Navigation>
          </div>
        </div>


      </template>
    </Carousel>
    <div v-else>
      <UiProductImage class="w-full max-h-screen object-contain" :title="'some title'" :url="images[0].url" fit="crop"
        :sizes="'sm:200px md:200px lg:100vw xl:100vw'" />
    </div>



  </div>
</template>

<script setup>

import { ref } from 'vue';
import { Carousel, Slide, Navigation, Pagination } from "vue3-carousel";
import { onMounted } from 'vue';
import { useEventListener, useWindowSize } from '@vueuse/core';
const UiClose = defineAsyncComponent(() => import('@/components/ui/close.vue'));


const props = defineProps({
  images: {
    type: Array,
    required: true
  },
  isExpanded: {
    type: Boolean,
    required: true
  }

});

const isZoomed = ref(false);
const isZooming = ref(false);
const mounted = ref(false);
const myCarousel = ref(null);

const translateX = ref(0);
const translateY = ref(0);

const { width } = useWindowSize();


// Skalfaktor – hur mycket du vill zooma in bilden.
const scaleFactor = 3;

const emit = defineEmits(['mytoggle', 'closeslideshow']);



const handleKeydown = (event) => {
  if (event.key === 'ArrowRight') {
    myCarousel.value.next();
  } else if (event.key === 'ArrowLeft') {
    myCarousel.value.prev();
  } else if (event.key === 'Escape') {

    if (isZoomed.value) {
      toggleZoom();
    } else {
      if (props.isExpanded) {

        emit('closeslideshow');
      }
    }
  }
};

onMounted(() => {
  mounted.value = true;
  useEventListener('keydown', (event) => {
    if (event.key === 'ArrowRight') {
      myCarousel.value.next();
    } else if (event.key === 'ArrowLeft') {
      myCarousel.value.prev();
    } else if (event.key === 'Escape') {

      if (isZoomed.value) {
        toggleZoom();
      } else {
        if (props.isExpanded) {

          emit('closeslideshow');
        }
      }
    }

  })

});

import { computed } from 'vue';

const sizes = computed(() => {
  if (props.isExpanded) {
    return '500px md:768px lg:1024px xl:2000px';
  }
  return '100vw md:60vw';
});


const toggleZoom = () => {

  if (width.value < 768) {
    return;
  }
  console.log('toggleZoom');
  console.log(props.isExpanded);
  if (!props.isExpanded) {
    return;
  }
  if (!isZoomed.value) {
    isZooming.value = true;
    // Starta zoom-animationen genom att sätta en klass med transition
    // Efter en viss tid (eller på transitionend) byter du state
    setTimeout(() => {
      isZooming.value = false;
      isZoomed.value = true;
    }, 300); // 300ms exempelvis
  } else {
    isZoomed.value = false;
  }
};

const handleMouseMove = (event) => {
  const rect = event.currentTarget.getBoundingClientRect();

  // Beräkna musens position relativt till elementets övre vänstra hörn
  const offsetX = event.clientX - rect.left;
  const offsetY = event.clientY - rect.top;

  // Ny translation med transform-origin 50% 50% (centrerat)
  translateX.value = (1 - scaleFactor) * (offsetX - rect.width / 2);
  translateY.value = (1 - scaleFactor) * (offsetY - rect.height / 2);
};

</script>

<style scoped>
@reference "../../assets/css/main.css";
.slide-content {
  transition: transform 0.3s ease-in-out, transform-origin 1.3s ease-in-out;
  transform-origin: 50% 50%;
}

.zooming {
  transition: transform 0.3s ease-in-out;
  transform: scale(3) !important;
}

.zoomed {
  transition: transform 0.1s linear;
  transform-origin: 50% 50%;
  /* Zoom in effect */

  cursor: zoom-out;
}

.cursor-zoom-in {
  cursor: zoom-in;
}

.cursor-zoom-out {
  cursor: zoom-out;
}

.carousel :deep(.carousel__slide) {
  display: block;
}

.carousel :deep(.carousel__next) {

  transform: none;
  position: inherit;
  margin: 0px 16px;
}

.fullscreenslider .carousel :deep(.carousel__next) {
  position: absolute;
  top: 50%;
  right: 10px;
  height: 42px;
}

.fullscreenslider .carousel :deep(.carousel__prev) {

  position: absolute;
  top: 50%;
  left: 10px;
  height: 42px;
  
}

.fullscreenslider .carousel .zoombutton {
  position: absolute;
  top: 20px;
  right: 0px;
}

.carousel :deep(.carousel__prev) {

  margin: 0px;
  transform: none;
  position: inherit;
}

.carousel {

  --vc-pgn-width: 25px;
  --vc-pgn-active-color: #E0DBCA;
  --vc-pgn-background-color: #ffffff66;


}

.carousel__pagination {
  @apply hidden lg:flex;
  bottom: inherit;
  left: inherit;
  position: relative !important;
  display: flex;
  transform: none;


}

.navigationwrapper {
  @apply pb-3 absolute bottom-0 w-full;

}

.fullscreenslider .navigationwrapper {
  position: initial;
}
</style>